export default "__VITE_ASSET__q42vZNsP$k3A73RSIvWJcw__"